import React from 'react';
import cls from 'classnames';
import './From.scss';
import { CusRadio } from './Radio';
/**
 * @param {object} props
 * @param {boolean} disabled
 */

function StaffFrom({
  children,
  disable,
  readonly,
  dflex,
  state,
  ...props
}) {
  return (
    <div className="w-100">
      <CusRadio
        checked={state}
        onChange={props.onChange}
        title={
          <span>
            {props.label ? <label className="mb-2">{props.label}</label> : null}
            {props.title ? <span className="text-base ml-2">{props.title}</span> : null}
            <input
              type="text"
              {...props}
              className={cls(
                'w-20 input-text ml-2',
                props.className
              )}
              maxLength={props.maxLength}
              onKeyPress={props.onKeyPress}
            >
            </input>
            {children}
          </span>
        }
      />
      {props.memo ? <p className='ml-9 text-sm text-rose-800'>{props.memo}</p> : null}
    </div>
  );
}

export { StaffFrom };
